<script>
import $ from 'domtastic';
import mixins from './vueMixins';

import './stylesheets/components/VsLazyLoad';

export default {
  props: {
    threshold: [String, Number],
    canLoad: [String, Boolean],
    type: String,
    element: Object,
  },
  mixins: [mixins],
  data: () => ({
    offset: null,
  }),
  mounted() {
    if (this.element) {
      $(this.element).on('scroll', this.scrollFunc);
    } else {
      $(window).on('scroll', this.scrollFunc);
    }
  },
  beforeDestroy() {
    if (this.element) {
      $(this.element).off('scroll', this.scrollFunc);
    } else {
      $(window).off('scroll', this.scrollFunc);
    }
  },
  methods: {
    scrollFunc() {
      if (this.element) {
        let element = $(this.element)[0];
        if (this.canLoad && element.scrollTop + element.offsetHeight >= element.scrollHeight - parseInt(this.threshold) || 0) this.$emit('load');
      } else {
        if (this.canLoad && this.scrollTop() + this.windowHeight() >= this.scrollHeight() - parseInt(this.threshold) || 0) this.$emit('load');
      }
    },
  },
};
</script>

<template lang='pug'>
.lazy-load__container(:class='{ "lazy-load__container--campaigns": type === "campaigns" }')
  slot
</template>